import { Routes } from '@angular/router';
import { menuConfig } from './config/menu-config';

import { AuthGuardService } from './guards/auth-guard.service';
import { MemberComponent } from './components/member/member.component';
import { SpeedflirtComponent } from './components/speedflirt/speedflirt.component';
import { AlbumComponent } from './components/album/album.component';
import { UploadComponent } from './components/album/upload.component';
import { ChatlistComponent } from './components/chat/chatlist.component';
import { EditProfileComponent } from './components/profile/edit-profile/edit-profile.component';
import { ChatComponent } from './components/chat/chat.component';
import { ChatActionsComponent } from './components/chat/chat-actions.component';
import { MyProfileComponent } from './components/profile/my-profile/my-profile.component';
import { SearchComponent } from './components/profile/search/search.component';
import { IndexComponent } from './components/account/index/index.component';
import { PasswordComponent } from './components/account/password/password.component';
import { IdentityComponent } from './components/account/identity/identity.component';
import { GsmComponent } from './components/account/gsm/gsm.component';
import { NotificationsComponent } from './components/account/notifications/notifications.component';
import { EmailComponent } from './components/account/email/email.component';
import { LegalsComponent } from './components/legals/legals.component';
import { BlacklistComponent } from './components/profile/blacklist/blacklist.component';
import { LanguageComponent } from './components/account/language/language.component';

// Nested routes
// http://blog.angular-university.io/angular-2-router-nested-routes-and-nested-auxiliary-routes-build-a-menu-navigation-system/
export const MemberRoutes: Routes = [
    {
        path: 'member',
        component: MemberComponent,
        canActivate: [AuthGuardService],
        children: [
            {
                path: 'home',
                component: SpeedflirtComponent,
                data: {
                    mode: 'speedflirt',
                    menuItems: menuConfig.home
                }
            },
            {
                path: 'chat',
                children: [
                    {
                        path: '',
                        component: ChatlistComponent,
                        data: {
                            menuItems: menuConfig.chat
                        }
                    },
                    {
                        path: ':id',
                        children: [
                            {
                                path: '',
                                component: ChatComponent,
                                data: {
                                    menuItems: menuConfig.chatProfile
                                }
                            },
                            {
                                path: '',
                                component: ChatActionsComponent
                            },
                        ]
                    },
                ]
            },
            {
                path: 'profile',
                children: [
                    {
                        path: 'album',
                        children: [
                            {
                                path: '',
                                component: AlbumComponent,
                                data: {
                                    menuItems: menuConfig.album
                                }
                            },
                            {
                                path: 'upload',
                                component: UploadComponent,
                                data: {
                                    menuItems: menuConfig.profile
                                }
                            },
                            {
                                path: ':id',
                                component: AlbumComponent,
                                data: {
                                    menuItems: menuConfig.album
                                }
                            }
                        ]
                    },
                    {
                        path: 'edit',
                        component: EditProfileComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'my-profile',
                        component: MyProfileComponent,
                        data: {
                            menuItems: menuConfig.profile
                        }
                    },
                    {
                        path: 'search',
                        component: SearchComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'blacklist',
                        component: BlacklistComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: ':id',
                        component: SpeedflirtComponent,
                        data: {
                            mode: 'profile',
                            menuItems: menuConfig.back
                        }
                    }
                ]
            },
            {
                path: 'account',
                children: [
                    {
                        path: '',
                        component: IndexComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'password',
                        component: PasswordComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'identity',
                        component: IdentityComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'gsm',
                        component: GsmComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'notifications',
                        component: NotificationsComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'legals/:type',
                        component: LegalsComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'email',
                        component: EmailComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    },
                    {
                        path: 'language',
                        component: LanguageComponent,
                        data: {
                            menuItems: menuConfig.back
                        }
                    }
                ]
            },
            {
                path: '**',
                redirectTo: 'home'
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/app.route.member.ts